import _ from 'lodash';

// Safely access storage to prevent errors
const safeGetStorage = (storage, key) => {
  try {
    return storage.getItem ? storage.getItem(key) : storage[key];
  } catch (error) {
    console.warn(`Error accessing storage for key ${key}:`, error);
    return null;
  }
};

const safeSetStorage = (storage, key, value) => {
  try {
    if (storage.setItem) {
      storage.setItem(key, value);
    } else {
      storage[key] = value;
    }
  } catch (error) {
    console.warn(`Error setting storage for key ${key}:`, error);
  }
};

const user = {
  accessToken: null,
  rememberMe: false,
  currentUserId: null,
  currentUser: null,
};

const getCurrentUser = () => user.currentUser;
const updateCurrentUser = (obj) => (user.currentUser = obj);
const getAuthData = () => ({
  accessToken: user.accessToken,
  rememberMe: user.rememberMe,
  currentUserId: user.currentUserId,
});
const updateAuthData = (obj) => {
  if (obj.accessToken) user.accessToken = obj.accessToken;
  if (obj.currentUserId) user.currentUserId = obj.currentUserId;
  if (obj.rememberMe) user.rememberMe = obj.rememberMe;
};
const updateStorage = (obj) => {
  const storage = obj.rememberMe ? localStorage : sessionStorage;

  if (obj.accessToken) {
    safeSetStorage(storage, '$LoopBack$accessTokenId', obj.accessToken);
    // Also store in the new 'auth' key for consistency
    safeSetStorage(storage, 'auth', obj.accessToken);
  }
  if (obj.currentUserId) {
    safeSetStorage(storage, '$LoopBack$currentUserId', obj.currentUserId);
    // Also store in the new 'userId' key for consistency
    safeSetStorage(storage, 'userId', obj.currentUserId);
  }
  if (obj.rememberMe) safeSetStorage(storage, '$LoopBack$rememberMe', obj.rememberMe);
};
const clearUserData = () => {
  const storages = [localStorage, sessionStorage];
  const keysToRemove = [
    '$LoopBack$accessTokenId',
    '$LoopBack$currentUserId',
    '$LoopBack$rememberMe',
    'auth',
    'userId',
    'refreshToken',
  ];

  _.forEach(storages, (storage) => {
    keysToRemove.forEach((key) => {
      try {
        storage.removeItem(key);
        // Also set to null for backward compatibility
        storage[key] = null;
      } catch (error) {
        console.warn(`Error clearing storage key ${key}:`, error);
      }
    });
  });

  user.accessToken = null;
  user.rememberMe = false;
  user.currentUserId = null;
  user.currentUser = null;
};

// read localStorage or SessionStorage for auth data
user.accessToken =
  safeGetStorage(localStorage, '$LoopBack$accessTokenId') ||
  safeGetStorage(sessionStorage, '$LoopBack$accessTokenId') ||
  safeGetStorage(localStorage, 'auth') ||
  safeGetStorage(sessionStorage, 'token');
user.currentUserId =
  safeGetStorage(localStorage, '$LoopBack$currentUserId') ||
  safeGetStorage(sessionStorage, '$LoopBack$currentUserId') ||
  safeGetStorage(localStorage, 'userId');
user.rememberMe =
  safeGetStorage(localStorage, '$LoopBack$rememberMe') || safeGetStorage(sessionStorage, '$LoopBack$rememberMe');

export default {
  getCurrentUser,
  updateCurrentUser,
  getAuthData,
  updateAuthData,
  updateStorage,
  clearUserData,
};
